import { render, staticRenderFns } from "./events-company.vue?vue&type=template&id=65aaf6b5&"
import script from "./events-company.vue?vue&type=script&lang=js&"
export * from "./events-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports